import React from 'react'
import { TABLA_CDMD_EXPORTADOR_CEREAL } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

function CamionesEnCircuitoExpCerealView () {
  return <MuiTable id={TABLA_CDMD_EXPORTADOR_CEREAL} />
}

export default CamionesEnCircuitoExpCerealView
